function parseMaxSize(str) {
  if(!str) return 0;
  var match = str.toLowerCase().match(/^(\d+(?:\.\d+)?)\s*(kb|mb|gb)$/);
  if(!match) return 0;
  var num = parseFloat(match[1]);
  var unit = match[2];
  if(unit === 'kb') return num * 1024;
  if(unit === 'mb') return num * 1024 * 1024;
  if(unit === 'gb') return num * 1024 * 1024 * 1024;
  return 0;
}

export function fileUpload() {
  const containers = document.querySelectorAll('.js-file-upload');
  if(containers.length) {
    for (let i = 0; i < containers.length; i++) {
      const wrapper = containers[i];
      const input = wrapper.querySelector('input[type="file"]');
      if(!input) continue;

      // Skip if already initialized
      if(wrapper.classList.contains('is-init')) continue;
      wrapper.classList.add('is-init');

      const acceptRaw = wrapper.dataset.accept || '';
      const extensions = acceptRaw ? acceptRaw.split(',').map(function(ext) {
        var e = ext.trim().toLowerCase();
        return e.charAt(0) === '.' ? e : '.' + e;
      }) : [];
      const mainText = wrapper.dataset.text || 'ドラッグ&ドロップ\nまたはクリックしてファイルを選択してください。';
      const subText = wrapper.dataset.subtext || '';
      const maxSizeRaw = wrapper.dataset.maxsize || '';
      const maxSizeBytes = parseMaxSize(maxSizeRaw);

      // Build inner elements
      const inner = document.createElement('div');
      inner.className = 'file-upload__inner';

      const icon = '<svg class="file-upload__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 85.039 85.039">' +
        '<path d="M2.266 32.456v-24.6c0-1.17 1.065-2.235 2.236-2.235h76.035c1.17 0 2.236 1.065 2.236 2.236v24.6c0 1.17-1.065 2.236-2.236 2.236h-13.37c-1.182.017-2.268-1.055-2.268-2.237 0-1.181 1.086-2.253 2.268-2.236H78.3V10.093H6.739V30.22h11.134c1.181-.017 2.268 1.055 2.268 2.236 0 1.182-1.087 2.253-2.268 2.237H4.503c-1.224 0-2.236-1.19-2.237-2.237z"/>' +
        '<path d="M42.52 21.275c-.518 0-1.205.313-1.538.63l-19.01 17.89c-.863.836-.963 2.19-.087 3.163.784.87 2.312.892 3.163.087l15.235-14.36v48.497a2.236 2.236 0 104.473 0V28.684L59.99 43.045c.85.805 2.341.748 3.162-.087.867-.882.79-2.34-.087-3.162l-19.01-17.89c-.515-.526-1.011-.622-1.536-.63v-.001z"/>' +
      '</svg>';

      const mainHtml = mainText.replace(/\n/g, '<br>');
      const text = '<span class="file-upload__text">' +
        '<span class="file-upload__main textalign-center lh1_5">' + mainHtml + '</span>' +
        (subText ? '<span class="file-upload__sub textalign-center lh1_5">' + subText.replace(/\n/g, '<br>') + '</span>' : '') +
      '</span>';

      const status = document.createElement('div');
      status.className = 'file-upload__status';
      status.textContent = 'まだファイルがアップロードされていません';

      inner.innerHTML = icon + text;
      inner.appendChild(status);
      wrapper.insertBefore(inner, wrapper.firstChild);

      function validateFile(file) {
        if(extensions.length) {
          const fileExt = '.' + file.name.split('.').pop().toLowerCase();
          if(extensions.indexOf(fileExt) === -1) {
            return 'type';
          }
        }
        if(maxSizeBytes && file.size > maxSizeBytes) {
          return 'size';
        }
        return '';
      }

      function showStatus(file) {
        var error = validateFile(file);
        if(error === 'type') {
          status.textContent = 'このファイル形式は受け付けていません。';
          wrapper.classList.add('has-error');
          wrapper.classList.remove('has-file');
        } else if(error === 'size') {
          status.textContent = 'ファイルサイズが上限（' + maxSizeRaw + '）を超えています。';
          wrapper.classList.add('has-error');
          wrapper.classList.remove('has-file');
        } else {
          status.textContent = '\u2705 ' + file.name;
          wrapper.classList.add('has-file');
          wrapper.classList.remove('has-error');
        }
      }

      function clearStatus() {
        status.textContent = 'まだファイルがアップロードされていません';
        wrapper.classList.remove('has-file');
        wrapper.classList.remove('has-error');
      }

      // Show selected file name
      input.addEventListener('change', function() {
        if(input.files && input.files.length > 0) {
          showStatus(input.files[0]);
        } else {
          clearStatus();
        }
      });

      // Drag & drop events
      wrapper.addEventListener('dragover', function(e) {
        e.preventDefault();
        e.stopPropagation();
        wrapper.classList.add('is-dragover');
      });

      wrapper.addEventListener('dragleave', function(e) {
        e.preventDefault();
        e.stopPropagation();
        wrapper.classList.remove('is-dragover');
      });

      wrapper.addEventListener('drop', function(e) {
        e.preventDefault();
        e.stopPropagation();
        wrapper.classList.remove('is-dragover');

        const files = e.dataTransfer.files;
        if(files.length > 0) {
          const file = files[0];
          if(validateFile(file)) {
            showStatus(file);
            return;
          }

          // Set files to input via DataTransfer
          const dt = new DataTransfer();
          dt.items.add(file);
          input.files = dt.files;

          // Trigger change event for CF7
          const event = new Event('change', { bubbles: true });
          input.dispatchEvent(event);
        }
      });
    }
  }
}
